/* eslint-disable no-underscore-dangle */
import superagentPromise from 'superagent-promise';
import _superagent from 'superagent';

const superagent = superagentPromise(_superagent, Promise);

const responseBody = (res) => res.body;
const apiUrl = window.__ENV && window.__ENV.apiUrl;
const requests = {
  post: (url, body) =>
    superagent
      .post(url, body)
      .set('Content-Type', 'application/json')
      .then(responseBody),
  get: (url, body) =>
    superagent
      .get(url, body)
      .redirects(0)
      .ok((res) => {
        if (res.status === 302) console.log(res);
      })
      .end(),
  postData: (url, body) =>
    superagent
      .post(url, body)
      .set('Content-Type', 'application/json')
      .then(responseBody),
  getWithToken: (url, token) =>
    superagent
      .get(url)
      .set('Content-Type', 'application/json')
      .set('Authorization', `Bearer ${token}`)
      .then(responseBody),
  postWithToken: (url, body, token) =>
    superagent
      .post(url, body)
      .set('Content-Type', 'application/json')
      .set('Authorization', `Bearer ${token}`)
      .then(responseBody),
  deleteWithToken: (url, token) =>
    superagent
      .del(url, token)
      .set('Content-Type', 'application/json')
      .set('Authorization', `Bearer ${token}`)
      .then(responseBody),
  putWithToken: (url, body, token) =>
    superagent
      .put(url, body, token)
      .set('Content-Type', 'application/json')
      .set('Authorization', `Bearer ${token}`)
      .then(responseBody),
  uploadWithToken: (url, data, token) =>
    superagent
      .post(url, data)
      .set('Authorization', `Bearer ${token}`)
      .then(responseBody),
};

const Auth = {
  login: (email: string, password: string) => {
    /* eslint-disable prefer-template */
    const formData = ({
      userName: email,
      Password: password,
    });

    return requests.postData(`${apiUrl}/api/Auth`, formData);
  },
  getCurrentUser: (accessToken: string) => {
    return requests.getWithToken(`${apiUrl}/api/User/Profile`, accessToken);
  },
  getInvoices: (accessToken: string) => {
    return requests.getWithToken(`${apiUrl}/api/Invoices`, accessToken);
  },
  getInvoiceDetails: (accessToken: string, id) => {
    return requests.getWithToken(`${apiUrl}/api/Invoices/details?id=${id}`, accessToken);
  },
};


export default {
  Auth
};
